// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block; /* Custom elements often need display: block */
  position: fixed;
  top: 0;
  right: -640px; /* Initially off-screen */
  width: 640px;
  height: 100%;
  background: var(--Colors-UI-Neutral-Grey-100, #F5F5F5);
  transition: right 0.3s ease-in-out; /* Slide in animation */
  z-index: 1000;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
}
:host(.open) {
  right: 0; /* Slides into view */
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;
  z-index: 999;
}
:host(.open) + .overlay {
  opacity: 1;
  pointer-events: auto;
}

.back-button {
  cursor: pointer;
}
.title {
}

`, "",{"version":3,"sources":["webpack://./src/blade.css"],"names":[],"mappings":"AAEA;EACE,cAAc,EAAE,8CAA8C;EAC9D,eAAe;EACf,MAAM;EACN,aAAa,EAAE,yBAAyB;EACxC,YAAY;EACZ,YAAY;EACZ,sDAAsD;EACtD,kCAAkC,EAAE,uBAAuB;EAC3D,aAAa;EACb,yCAAyC;AAC3C;AACA;EACE,QAAQ,EAAE,qBAAqB;AACjC;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,UAAU;EACV,oBAAoB;EACpB,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;AACA;AACA","sourcesContent":["@import url(\"./global.css\");\n\n:host {\n  display: block; /* Custom elements often need display: block */\n  position: fixed;\n  top: 0;\n  right: -640px; /* Initially off-screen */\n  width: 640px;\n  height: 100%;\n  background: var(--Colors-UI-Neutral-Grey-100, #F5F5F5);\n  transition: right 0.3s ease-in-out; /* Slide in animation */\n  z-index: 1000;\n  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);\n}\n:host(.open) {\n  right: 0; /* Slides into view */\n}\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease-in-out;\n  z-index: 999;\n}\n:host(.open) + .overlay {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.back-button {\n  cursor: pointer;\n}\n.title {\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
